import React from 'react'
import { WorkModel } from '@Entities/work/work'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'
import './index.scss'
import day from 'dayjs'
import CopyWorkButton from '@Components/Buttons/CopyWorkButton'

interface RegHistoryWorkHeaderProps {
    work: WorkModel
}

const RegHistoryWorkHeader = ({ work }: RegHistoryWorkHeaderProps) => (
    <ViewWorkHeader work={work} showOverclaimLink>
        <div className="sub-data">
            <CopyWorkButton work={work} workId={work.id} />
            {work.submissionDate && (
                <div className="submission-date">
                    Submission Date:
                    <span className="bold">
                        {work.submissionDate &&
                            day(work.submissionDate, 'YYYY-MM-DD')
                                .toDate()
                                .toLocaleString('default', { month: 'long', day: '2-digit', year: 'numeric' })}
                    </span>
                </div>
            )}
        </div>
    </ViewWorkHeader>
)

export default RegHistoryWorkHeader
